export class ChatbotStateModel {
	sessionId: string;
	orderId: string | number;
	constructor() {
		this.sessionId = null;
		this.orderId = null;
	}
}
